import React from 'react'
import"./ContactPhase1.css"
const ContactPhase1 = () => {
  return (
    <div className='contactphase1'>
        <div className="parabox">
        <p className="about">Contact</p>
        <p className="paraabout"style={{ textAlign: "center" }}>Get In Touch</p>
        </div>
    </div>
  )
}

export default ContactPhase1